module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=LR - Liberia.db1d75d2.svg";